import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { Account } from '../../models/account'
import { groupBy } from '../../helpers/helpers';
import { DocumentSettings } from '../../models/document-settings';

interface InitialState {
  settings: DocumentSettings[] | undefined;
  customers: Account[] | undefined;
  items: Account[] | undefined;
  works: Account[] | undefined;
  cars: Account[] | undefined;
  incomes: Account[] | undefined;
  outcomes: Account[] | undefined;
  banks: Account[] | undefined;
  cashBoxes: Account[] | undefined;
  system: Account[] | undefined;
}

const initialState: InitialState = {
  settings: undefined,
  customers: undefined,
  items: undefined,
  works: undefined,
  cars: undefined,
  incomes: undefined,
  outcomes: undefined,
  banks: undefined,
  cashBoxes: undefined,
  system: undefined,
}

export const accounts = createSlice({
  name: 'documents',
  initialState,
  reducers: {
    setDocumentsSettings: (state, action: PayloadAction<DocumentSettings[] | undefined>)=>{
      state.settings = action.payload
    },
    setAllAccountsData: (state, action: PayloadAction<Account[] | undefined>) => {
      const groupsObject = groupBy(action.payload, 'account_type');
      setGroupsInState(groupsObject, state);
    },
    setCustomers: (state, action: PayloadAction<Account[] | undefined>) => {
      state.customers = action.payload
    },
    setItems: (state, action: PayloadAction<Account[] | undefined>) => {
      state.items = action.payload
    },
    setWorks: (state, action: PayloadAction<Account[] | undefined>) => {
      state.works = action.payload
    },
    setCars: (state, action: PayloadAction<Account[] | undefined>) => {
      state.cars = action.payload
    },
    setIncomes: (state, action: PayloadAction<Account[] | undefined>) => {
      state.incomes = action.payload
    },
    setOutcomes: (state, action: PayloadAction<Account[] | undefined>) => {
      state.outcomes = action.payload
    },
    setBanks: (state, action: PayloadAction<Account[] | undefined>) => {
      state.banks = action.payload
    },
    setCashBoxes: (state, action: PayloadAction<Account[] | undefined>) => {
      state.cashBoxes = action.payload
    },
    setSystem: (state, action: PayloadAction<Account[] | undefined>) => {
      state.system = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase('logout', () => initialState); // Reset to initial state on logout
  },
})


interface GroupsObject{
  'לקוח-ספק'? : Account[];
  'פריט'? : Account[];
  'עבודה'? : Account[];
  'רכב'? : Account[];
  'הכנסה'? : Account[];
  'הוצאה'? : Account[];
  'קופה'? : Account[];
  'בנק'? : Account[];
  'מערכת'? : Account[];
}

function setGroupsInState(groupsObject: GroupsObject | undefined, state: InitialState) {

  state.customers = groupsObject?.["לקוח-ספק"] || [];
  state.items = groupsObject?.["פריט"];
  state.works = groupsObject?.["עבודה"];
  state.cars = groupsObject?.["רכב"];
  state.incomes = groupsObject?.["הכנסה"];
  state.outcomes = groupsObject?.["הוצאה"];
  state.cashBoxes = groupsObject?.["קופה"];
  state.banks = groupsObject?.["בנק"];
  state.system = groupsObject?.["מערכת"];
}

// Action creators are generated for each case reducer function
export const {
  setDocumentsSettings,
  setAllAccountsData,
  setCustomers,
  setItems,
  setWorks,
  setCars,
  setIncomes,
  setOutcomes,
  setBanks,
  setCashBoxes,
  setSystem 
} = accounts.actions

export default accounts.reducer